import { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { TrainingHistoryView } from "../VIEW/TrainingHistoryView";
import { useAuth } from "../FIREBASE/useAuth";
import { fetchTrainingHistory, setIntervalsCreds, hasIntervalsCreds } from "../FIREBASE/intervals";
import { loadCredentials } from "../FIREBASE/userSettings";
import { HistActivity, HistWellness } from "../COMPONENTS/trainingHistory";
import routeUrls from "../COMPONENTS/navbar/navLink";

const YEARS = 3;

function TrainingHistoryPage() {
  const { user, loading: authLoading } = useAuth();
  const history = useHistory();
  const [data, setData] = useState<{ activities: HistActivity[]; wellness: HistWellness[] } | null>(null);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!authLoading && !user) {
      history.replace(`${routeUrls.LOGIN}?from=${routeUrls.TRAINING_HISTORY}`);
    }
  }, [user, authLoading, history]);

  useEffect(() => {
    if (authLoading || !user) return;
    let cancelled = false;

    async function init() {
      if (!hasIntervalsCreds()) {
        const creds = await loadCredentials(user!.uid);
        if (cancelled) return;
        if (!creds) { history.push(routeUrls.CONNECT); return; }
        setIntervalsCreds(creds.apiKey, creds.athleteId);
      }
      try {
        const res = await fetchTrainingHistory(YEARS);
        if (cancelled) return;
        setData({ activities: res.activities as HistActivity[], wellness: res.wellness as HistWellness[] });
      } catch (err) {
        if (!cancelled) { console.error("Training history error:", err); setError("Kunde inte ladda träningshistoriken."); }
      }
    }

    init();
    return () => { cancelled = true; };
  }, [user, authLoading, history]);

  if (authLoading || !user) return null;
  if (error) return <p style={{ color: "#fff", padding: "2rem" }}>{error}</p>;
  return <TrainingHistoryView data={data} years={YEARS} />;
}

export default TrainingHistoryPage;
